//@flow
import { createFragmentContainer, graphql } from 'react-relay';
import getter from 'dibs-object-getter';
import LazyLoad from 'react-lazy-load';

import styles from './OverviewFavorites.scss';

import { createProductImpressionTracking, trackItemTile } from '../helpers/designProfileTracking';
import { trackEcomEvent } from '../../shared/helpers/tracking';
import type { OverviewFavoriteItem_item as Item } from './__generated__/OverviewFavoriteItem_item.graphql';

type Props = {
    item: ?Item,
    index?: number,
    isTrade: boolean,
};

export const OverviewFavoriteItemComponent = (props: Props) => (
    <div className="colXs6 colMd4 colLg2">
        <a
            href={getter(props.item).value('localizedPdpUrl')}
            className={styles.item}
            onClick={() => {
                const products = createProductImpressionTracking({
                    isTrade: props.isTrade,
                    items: [props.item],
                });
                if (products.length) {
                    trackItemTile(products[0]);
                }
            }}
        >
            <LazyLoad
                offset={200}
                once
                height={171}
                onContentVisible={() => {
                    trackEcomEvent({
                        type: 'productImpression',
                        products: createProductImpressionTracking({
                            isTrade: props.isTrade,
                            items: [props.item],
                            positionNum: props.index || 0,
                        }),
                    });
                }}
            >
                <img
                    src={getter(props.item).value('firstPhotoWebPath')}
                    className={styles.itemStyle}
                    alt={getter(props.item).value('title')}
                />
            </LazyLoad>
        </a>
    </div>
);

export const OverviewFavoriteItem = createFragmentContainer(OverviewFavoriteItemComponent, {
    item: graphql`
        fragment OverviewFavoriteItem_item on Item {
            serviceId
            firstPhotoWebPath(size: thumb)
            localizedPdpUrl
            title
            seller {
                serviceId
            }
            isContemporary
            isCustomizable
            isNewAndMadeToOrder
            classification {
                categories {
                    category {
                        key
                        browseUrl
                    }
                }
            }
            pricing {
                amount {
                    amount
                }
                netPrice {
                    amount
                }
                salePrice {
                    amount
                }
            }
        }
    `,
});
